import type {Injectable, Injector} from './types';
import {exists} from 'shared/utils/custom-utils';

export abstract class ClassInjector implements Injector {
    abstract getByToken<T>(token: string): T;

    public getByClass<T>(injectableClass: Injectable<T>) {
        if ('presenterName' in injectableClass && exists(injectableClass.presenterName)) {
            return this.getByToken<T>(injectableClass.presenterName);
        }
        if ('serviceName' in injectableClass && exists(injectableClass.serviceName)) {
            return this.getByToken<T>(injectableClass.serviceName);
        }
        if ('providerName' in injectableClass && exists(injectableClass.providerName)) {
            return this.getByToken<T>(injectableClass.providerName);
        }
        throw new Error(`Can not inject ${injectableClass.toString()}`);
    }

    tryGetByClass<T>(injectableClass: Injectable<T>): T | undefined {
        let name = 'unknown';

        if ('presenterName' in injectableClass && exists(injectableClass.presenterName)) {
            name = injectableClass.presenterName;
        }

        if ('serviceName' in injectableClass && exists(injectableClass.serviceName)) {
            name = injectableClass.serviceName;
        }

        try {
            return this.getByToken<T>(name);
        } catch {
            // eslint-disable-next-line no-console
            console.warn(`Can not inject ${name}`);
            return undefined;
        }
    }
}

export class AngularManualInjector extends ClassInjector implements Injector {

    constructor(private readonly angularInjector: angular.auto.IInjectorService) {
        super();
    }

    getByToken<T>(token: string): T {
        return this.angularInjector.get(token);
    }
}